import { render, staticRenderFns } from "./markProcess.vue?vue&type=template&id=57a97be5&scoped=true&xmlns%3Ael-col=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&"
import script from "./markProcess.vue?vue&type=script&lang=js&"
export * from "./markProcess.vue?vue&type=script&lang=js&"
import style0 from "./markProcess.vue?vue&type=style&index=0&id=57a97be5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a97be5",
  null
  
)

export default component.exports